//initial formik form values
export const initialValue = {
    postcode: 2000
};